'use strict';

document.addEventListener('DOMContentLoaded', () => {
// ---------- Compare / Before-After slider ----------
const compareBoxImg = document.querySelectorAll('.compare__box-img');
compareBoxImg.forEach(boxImg => {
  const compareContainer = boxImg.querySelector('.compare__wrapper');
  const overlay = boxImg.querySelector('.compare__overlay');
  const slider = boxImg.querySelector('.compare__slider');

  let isDragging = false;

  const startDragging = event => {
    isDragging = true;
    document.addEventListener('mousemove', drag);
    document.addEventListener('mouseup', stopDragging);
    document.addEventListener('touchmove', drag);
    document.addEventListener('touchend', stopDragging);
  };

  const drag = event => {
    if (!isDragging) return;
    const clientX = event.touches ? event.touches[0].clientX : event.clientX;
    const rect = compareContainer.getBoundingClientRect();
    const offsetX = Math.min(Math.max(clientX - rect.left, 0), rect.width);
    const newWidth = (offsetX / rect.width) * 100;
    overlay.style.width = `${newWidth}%`;
    slider.style.left = `${newWidth}%`;
  };

  const stopDragging = () => {
    isDragging = false;
    document.removeEventListener('mousemove', drag);
    document.removeEventListener('mouseup', stopDragging);
    document.removeEventListener('touchmove', drag);
    document.removeEventListener('touchend', stopDragging);
  };

  slider.addEventListener('mousedown', startDragging);
  slider.addEventListener('touchstart', startDragging);
});
// ---------- Reviews slider ----------
const reviewsContainer = document.querySelector('.reviews__container');
const reviews = document.querySelectorAll('.reviews__review');
const reviewsPrevBtn = document.querySelector('.reviews__prev');
const reviewsNextBtn = document.querySelector('.reviews__next');

let i = 0;
function getReviewWidth() {
  return reviews[0].offsetWidth + 20;
}
function updateSlider() {
  const reviewWidth = getReviewWidth();
  reviewsContainer.style.transform = `translateX(-${i * reviewWidth}px)`;
  reviewsPrevBtn.disabled = (i === 0);
  reviewsNextBtn.disabled = (i >= reviews.length - 1);
}
reviewsPrevBtn.addEventListener('click', () => {
  if (i > 0) {
    i--;
    updateSlider();
  }
});
reviewsNextBtn.addEventListener('click', () => {
  if (i < reviews.length - 1) {
    i++;
    updateSlider();
  }
});
window.addEventListener('resize', updateSlider);
updateSlider();

// ---------- FAQ accordion ----------
const faqButtons = document.querySelectorAll('.faq__btn');
faqButtons.forEach(btn => {
  btn.addEventListener('click', function () {
    const content = this.nextElementSibling;
    const isOpen = content.style.height && content.style.height !== '0px';
    document.querySelectorAll('.faq__answer').forEach(item => {
      item.style.height = '0';
      item.style.opacity = '0';
      item.style.padding = '0';
      item.style.backgroundColor = 'transparent';
    });
    faqButtons.forEach(b => b.classList.remove('active'));

    if (isOpen) {
      content.style.height = content.scrollHeight + 'px';
      setTimeout(() => {
        content.style.height = '0';
        content.style.opacity = '0';
        content.style.padding = '0';
        content.style.backgroundColor = 'transparent';
      }, 10);
      this.classList.remove('active');
    } else {
      content.style.height = content.scrollHeight + 'px';
      content.style.opacity = '1';
      content.style.padding = '2rem';
      content.style.backgroundColor = '#ce8806c0';
      this.classList.add('active');
      setTimeout(() => {
        content.style.height = 'auto';
      }, 10);
    }
  });
});
});